import { InputHTMLAttributes } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
}

export const Input = ({ name, ...rest }: InputProps) => {
  return (
    <div className="my-2 flex h-8 w-full items-center justify-between gap-4">
      <p className="w-2/6 font-medium text-gray-700">{name}: </p>

      <input type="text" {...rest} name={name} className="h-full w-full bg-gray-200 p-2 placeholder:text-gray-600" />
    </div>
  );
};
